import { render } from "./FontEditor.vue?vue&type=template&id=19b3bf1c&scoped=true"
import script from "./FontEditor.vue?vue&type=script&lang=js"
export * from "./FontEditor.vue?vue&type=script&lang=js"

import "./FontEditor.vue?vue&type=style&index=0&id=19b3bf1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b3bf1c"]])

export default __exports__